import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { EquipmentTypeResponse } from "../../services/responses/form/equipment-type.response";

@Injectable({
    providedIn: 'root'
  })
  export class SelectService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient) {
      super();
    }

    public getSelectValues(uri:string, searchText: string): Observable<any>{
      let completeUrl = uri;
      if(searchText){
        if(completeUrl.slice(-1) == "&")
          completeUrl = completeUrl+`searchText=${searchText}`;
        else
          completeUrl = completeUrl+`?searchText=${searchText}`;
      }

      return this.httpClient.get<any>(completeUrl, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }


}